import axios from "axios";
import authService from "@/services/auth.service";

const API_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_HOST_DESARROLLO
    : process.env.VUE_APP_HOST_PRODUCCION;

const httpClient = axios.create({
  baseURL: `${API_ENDPOINT}/v1/campus/`,
});

httpClient.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${authService.getToken()}`;
  return config;
});

export default {
  /**
   * Obtiene todas las ofertas del catálogo del campus
   */
  async getOfertas() {
    const response = await httpClient.get("ofertas");
    return response.data;
  },

  /**
   * Inscribe un estudiante en un aula del campus
   * @param {string} dni - DNI del estudiante
   * @param {number} ofertaId - ID de la oferta/aula
   * @param {number} alumnoCursadoId - ID del registro alumno_cursado (opcional)
   */
  async inscribir(dni, ofertaId, alumnoCursadoId = null) {
    const data = {
      dni: dni,
      oferta_id: ofertaId,
    };
    if (alumnoCursadoId) {
      data.alumno_cursado_id = alumnoCursadoId;
    }
    const response = await httpClient.post("inscribir", data);
    return response.data;
  },

  /**
   * Inscribe múltiples estudiantes en un aula del campus (optimizado)
   * @param {Array} inscripciones - Array de {dni, alumno_cursado_id}
   * @param {number} ofertaId - ID de la oferta/aula
   */
  async inscribirMultiples(inscripciones, ofertaId) {
    const response = await httpClient.post("inscribir-multiples", {
      inscripciones: inscripciones,
      oferta_id: ofertaId,
    });
    return response.data;
  },
};
